<template>
    <div class="contract-row py-5">
        <div class="flex items-center justify-between w-full" v-if="showInfo">
            <div class="flex items-center">
                <div class="mr-3">
                    <md-button class="md-icon-button md-info" @mousedown="goToRoute($event, 'Site Details', { 'idSite': site.id })">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                    </md-button>
                    <md-tooltip md-direction="top" style="min-width: max-content !important;">
                        <b>{{ site.name }}</b>
                        <p class="mb-0">{{ site.address.addresses }}</p>
                        <p class="mb-0">{{ site.address.zip_code + ' - ' + site.address.city }}</p>
                        <p class="mb-0 font-bold italic">Cliquez pour accéder à la fiche du site</p>
                    </md-tooltip>
                </div>
                <span class="text-base">{{ site.name }}</span>
            </div>
            <div class="flex items-center justify-end pr-0.5" style="min-width: 150px;">
                <span class="mt-0.5">{{ site.devices.length }} dispositifs</span>
                <div class="ml-3">
                    <md-button class="md-icon-button md-info" @mousedown="goToRoute($event, 'Site Devices Edit', { 'idSite': site.id })">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                    </md-button>
                    <md-tooltip md-direction="top" style="min-width: max-content !important;">
                        <template v-if="site.devices.length > 0">
                            <p class="mb-0" v-for="deviceType in site.deviceTypes" :key="deviceType.id">{{ deviceType.count + ' : ' + deviceType.name }}</p>
                        </template>
                        <p v-else class="mb-0">Aucun dispositif pour ce site.</p>
                        <p class="mb-0 font-bold italic">Cliquez pour accéder à la liste des dispositifs</p>
                    </md-tooltip>
                </div>
            </div>
        </div>
        <div class="mt-2">
            <p class="font-bold mb-0">Actions</p>
            <div class="flex items-start mt-0.5">
                <div class="mr-3">
                    <md-button class="md-icon-button md-info" @mousedown="goToRoute($event, 'Add Site Contract', { 'idSite': site.id })">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'plus-circle']" />
                        <span class="font-medium leading-none ml-2">Ajouter un contrat</span>
                    </md-button>
                </div>
                <template v-if="copiedContract.id">
                    <md-button class="md-icon-button md-default" @click="duplicateModal = true">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'paste']" />
                        <span class="font-medium leading-none ml-2">
                            Dupliquer le contrat :
                            <span class="font-bold">{{ copiedContract.number }}</span>
                        </span>
                    </md-button>
                    <md-dialog :md-active.sync="duplicateModal" :md-fullscreen="false">
                        <md-content class="px-2 mt-3.5">
                            <div class="px-3">
                                <span class="text-xl font-medium">Duplication du contrat numéro <span class="text-info">{{ copiedContract.number }}</span></span>
                                <p class="text-sm font-light">
                                    Veuillez choisir un nouveau numéro de contrat, une date de début pour la première période
                                    <br />et un montant de base.
                                </p>
	                            <md-divider class="my-2"></md-divider>
	                            <p class="text-sm font-light" v-if="copiedContract.isCanceled && copiedContract.siteId === site.id">
		                            <span class="font-medium text-info">Duplication sur le même site d'un contrat résilié détecté :</span>
		                            les interventions planifiées après la date de résiliation seront transférées sur le nouveau contrat.
	                            </p>
                            </div>
                            <div class="md-layout mt-3">
                                <div class="md-layout-item md-size-100">
                                    <md-field class="md-invalid">
                                        <label>Numéro</label>
                                        <md-input v-model="contract.number" name="number" type="text" required></md-input>
                                        <validation-error :errors="apiValidationErrors.number"/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout mt-4">
                                <div class="md-layout-item md-size-50">
                                    <div class="md-vdatepicker">
                                        <datetime v-model="contract.dateStart" type="date" auto :phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
                                                  input-id="dateStart" :placeholder="this.$moment(new Date()).format('DD MMMM YYYY')"
                                        >
                                            <label slot="before">Date de début de la première période *</label>
                                        </datetime>
                                        <validation-error :errors="apiValidationErrors.date_start" />
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout mt-4 mb-5">
                                <div class="md-layout-item md-size-50">
                                    <md-field class="md-invalid">
                                        <label>Montant de base</label>
                                        <md-input v-model="contract.amount" name="amount" type="text" required></md-input>
                                        <validation-error :errors="apiValidationErrors.amount"/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout mt-2">
                                <div class="md-layout-item md-size-100">
                                    <span class="font-medium text-info text-lg">Détails</span>
                                </div>
                            </div>
                            <div class="md-layout mt-2">
                                <div class="md-layout-item md-size-100">
                                    <span><span class="font-medium">Site</span> : {{ site.name }}</span>
                                </div>
                            </div>
                            <div class="md-layout">
                                <div class="md-layout-item md-size-100">
                                    <span><span class="font-medium">Date de création du contrat</span> : {{ $moment(new Date()).format('DD/MM/YYYY') }}</span>
                                </div>
                            </div>
                        </md-content>
                        <md-dialog-actions>
                            <md-button class="md-warning" @click="duplicateModal = false">Annuler</md-button>
                            <md-button class="md-success" @click="duplicateContract">Dupliquer</md-button>
                        </md-dialog-actions>
                    </md-dialog>
                </template>
            </div>
        </div>
        <div v-if="type === 'with-contracts'" class="mt-4">
            <p class="font-bold mb-0">Contrat(s)</p>
            <div class="flex items-start justify-between w-full mt-0.5" v-for="contract in site.currentContracts" :key="contract.id">
                <div class="flex items-start w-full">
                    <div class="flex flex-col mr-3">
                        <div class="mb-2">
                            <md-button class="md-icon-button md-default" @click="copyContract(contract)">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'copy']" />
                            </md-button>
                            <md-tooltip md-direction="top">Copier le contrat</md-tooltip>
                        </div>
                    </div>
                    <contract-details :siteId="site.id" :contract="contract"></contract-details>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin'
import routerMixin from '@/mixins/router-mixin'
import ContractDetails from "@/pages/Clients/Sites-Contracts/components/ContractDetails";

export default {
    name: "ContractRow",
    components: {
        ValidationError, ContractDetails
    },
    mixins: [formMixin, dateTimeFormattingMixin, routerMixin],
    props: {
        site: Object,
        type: String,
        showInfo: Boolean
    },
    data() {
        return {
            duplicateModal: false,
            contract: {
                number: null,
                dateStart: null,
                amount: null
            }
        }
    },
    computed: mapState({
        copiedContract() {
            return this.$store.state.contracts.copied
        }
    }),
    methods: {
        async copyContract(contract) {
			try {
				const { data } = await this.$store.dispatch('contracts/copyContract', { id: contract.id })
				await this.$store.dispatch('alerts/success', `<div class="flex">Contrat numéro <span class="font-bold mx-1">${data.number}</span> copié</div>`)

				const payload = data.id ? {
					id: data.id,
					number: data.number,
					siteId: data.site_id,
					isCanceled: data.is_canceled,
				} : null
				await this.$store.dispatch('contracts/storeCopiedContract', payload)
			} catch (e) {}
        },
        async duplicateContract() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('contracts/duplicateContract', {
                    site_id: this.site.id,
                    number: this.contract.number,
                    date_start: this.contract.dateStart ? this.$moment(this.contract.dateStart).format('YYYY-MM-DD'): null,
                    amount: parseFloat(this.contract.amount),
                })
                this.duplicateModal = false
                this.$emit('duplicated')
                await this.$store.dispatch('alerts/success', `Contrat numéro <span class="font-bold mx-1">${this.copiedContract.number}</span> dupliqué`)
            } catch (e) {
	            if(e.response.data.errors) {
		            this.setApiValidation(e.response.data.errors)
	            } else {
					// Copied contract expired
		            this.duplicateModal = false
		            await this.$store.dispatch('contracts/storeCopiedContract', null)
	            }
            }
        },
    }
}
</script>

<style scoped lang="scss">
.contract-row {
    &:first-child {
        padding-top: 0;
    }
    &:last-child {
        padding-bottom: 0;
    }
    .md-layout-item.pl-0 {
        padding-left: 0 !important;
    }
    ::v-deep {
        .md-button {
            margin: 0;
            padding: 3.5px;
            height: 27px;
            line-height: 27px;
            min-width: 40px !important;
        }

        .button-icon-tooltip {
            .md-button {
                .md-button-content {
                    max-width: 14px !important;
                }
            }
        }
    }
}
</style>
